import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {SecurityUtils} from 'src/app/services/security.utils';
import {catchError} from 'rxjs/operators';
import {HttpClientUtils} from 'src/app/utils/http-client.utils';
import {CatalogTag, CatalogTagForm, DeleteCatalogTagForm} from 'src/app/services/model/catalog-tag.model';

@Injectable()
export class CatalogTagService {

  private serviceUrl = (tenantId: string) => `${environment.engineURL}/tenants/${tenantId}/catalog/tags`;

  constructor(protected httpClient: HttpClient) {
  }

  getCatalogTag(tenantId: string, tagId: string): Observable<CatalogTag> {
    return this.httpClient.get<CatalogTag>(`${this.serviceUrl(tenantId)}/${tagId}`, {
      headers: SecurityUtils.getAuthHttpHeaders()
    }).pipe(catchError(error => HttpClientUtils.handleError(error, null)));
  }

  getAllCatalogTagByTenantId(tenantId: string): Observable<CatalogTag[]> {
    return this.httpClient.get<CatalogTag[]>(`${this.serviceUrl(tenantId)}`, {
      headers: SecurityUtils.getAuthHttpHeaders()
    }).pipe(catchError(error => HttpClientUtils.handleError(error, [])));
  }

  createCatalogTagForTenant(tenantId: string, form: CatalogTagForm): Observable<string> {
    return this.httpClient.post<string>(`${this.serviceUrl(tenantId)}/for-tenant`, form, {
      headers: SecurityUtils.getAuthHttpHeaders()
    }).pipe(catchError(error => HttpClientUtils.handleError(error, null)));
  }

  deleteCatalogTags(tenantId: string, form: DeleteCatalogTagForm): Observable<boolean> {
	  return this.httpClient.post<boolean>(`${this.serviceUrl(tenantId)}/delete`, form, {
		  headers: SecurityUtils.getAuthHttpHeaders()
	  }).pipe(catchError(error => HttpClientUtils.handleError(error, false)));
  }
}
